// 通用公用方法
 
import   {instance,instancep}   from './baseurl.js'
const $https = ({method='get', url, data,type}) => {
   
    if(method!='get'){
        
        return instance.post(url+'?'+data)
    }else{
        console.log(url+'?'+data)
        return instance.get(url+'?'+data)
    }
   
 
};

// const $httpsp = ({method='get', url, data,type}) => {
   
//     if(method!='get'){
        
//         return instancep.post(url+'?'+data)
//     }else{
//         console.log(url+'?'+data)
//         return instancep.get(url+'?'+data)
//     }
   
 
// };
  
export  {$https}